/* eslint-disable no-new */
import Vue from 'vue'
import { isIOS } from '@mc/mc-base-env/src/web/platform'
import Compressor from 'compressorjs'
import { getGoodDefaultImg } from '../utils'
const modeMap = {
  fill: 'fixed',
  contain: 'lfit',
  cover: 'mfit'
}

export const ossImage = ({ src, width = 0, height = 0, mode } = {}) => {
  mode = modeMap[mode || 'fill']
  if (src && src.indexOf('img-oss') > 0) {
    const formatList = []
    if (width !== 0) {
      formatList.push(`/resize,m_${mode},w_${parseInt(width)}`)
    }
    if (height !== 0) {
      formatList.push(`,h_${parseInt(height)}`)
    }

    if (!isIOS()) {
      formatList.push('/format,webp')
    }
    if (src.indexOf('watermark') > 0) {
      if (src.indexOf('stage') > 0) {
        formatList.push(
          '/watermark,image_b3NzL3Rlc3QvMjdkNDc3ZWQ4NjYwNWQ2ZjJiM2JmNmIzNzc1MGNhNDUucG5n,g_center'
        )
      } else {
        formatList.push(
          '/watermark,image_b3NzL2RlZmF1bHQvYzA3YmI4ODIzNmYxNjEzMDViMWRkOGI0ZmE0NGZiMzgucG5n,g_center'
        )
      }
    }
    return src.split('?')[0] + '?x-oss-process=image' + formatList.join('')
  }
  return src
}

/**
 * [商品图片加载失败]
 * @param  {Object} e
 * @return  {string} src
 */
export const imgLoadFail = (e, defaultImg) => {
  if (defaultImg === 'HIDE') {
    e.target.style.display = 'none'
    return
  }

  defaultImg = defaultImg || getGoodDefaultImg()
  if (e.target.src !== defaultImg) {
    e.target.src = defaultImg
  }
  e.target.onerror = null // 防止闪图
}

export const ossHttpVersion = src => {
  if (!src || src.indexOf('img-oss') < 0) return src
  return src.replace(
    'img-oss.yunshanmeicai.com',
    'img-oss-h2.yunshanmeicai.com'
  )
}

const getImageWidth = file => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onload = function () {
      const img = new Image()
      img.onload = function () {
        resolve(img.width)
      }
      img.onerror = function () {
        resolve(-1)
      }
      img.src = fr.result
    }
    fr.onerror = function () {
      resolve(-1)
    }
    fr.readAsDataURL(file)
  })
}

export const compressImage = async param => {
  let file = param.file

  if (!file) return
  const width = await getImageWidth(file)

  if (
    param.targetSize > 0 &&
    param.targetSize > file.size &&
    width < param.maxWidth
  ) {
    return file
  }

  // 第一压缩幅度大，剩余循环压缩幅度小，需要循环改变参数进行压缩
  file = await pressImg(param)
  let maxCount = 3
  while (file && file.size > param.targetSize && maxCount > 0) {
    maxCount--
    const width = await getImageWidth(file)
    const scale = Math.sqrt(param.targetSize / file.size)
    const next = await pressImg({
      ...param,
      maxWidth: width > 0 ? Math.floor(width * scale) : undefined,
      file
    })
    if (!next) return file
    file = next
  }

  return file
}

const pressImg = async param => {
  return new Promise((resolve, reject) => {
    new Compressor(param.file, {
      // retainExif: true,
      quality: param.quality,
      convertSize: param.targetSize,
      maxWidth: param.maxWidth || 1080,
      // The compression process is asynchronous,
      // which means you have to access the `result` in the `success` hook function.
      success(result) {
        if (param.targetSize !== -1) {
          if (param.targetSize > result.size || result.size < param.file.size) {
            resolve(result)
          } else {
            resolve(null)
          }
        } else {
          // 返回文件流
          resolve(result)
        }
      },
      error(err) {
        console.log('图片压缩失败', err)
        resolve(null)
      }
    })
  })
}

export const onLoadP = async ({ ossData, file, subPath }) => {
  const formData = new FormData()

  formData.append('file', file)
  formData.append(
    'object',
    `${subPath || ''}${new Date().getTime()}${encodeURIComponent(file.name)}`
  )

  return Vue.http
    .post(ossData.ossUrl + '/api/oss/uploadFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...ossData.headers
      }
    })
    .then(res => {
      const { data } = res
      if (data.data) {
        return Promise.resolve(data)
      } else {
        return Promise.reject({ message: '图片上传失败，请稍候再试' })
      }
    })
    .catch(err => {
      return Promise.reject(err)
    })
}
